import axios from 'axios'
import constants from '../config/Constants'
import Enums from '../config/Enums'
export const HTTP = axios.create({
  baseURL: constants.MAIN_SERVER_URL
})
